export default function metrics() {
	// meter todo con delegates!
};


//////////////////
// WEBPACK FOOTER
// ./src/js/metrics.js
// module id = 10
// module chunks = 0